"use strict";

var _taggedTemplateLiteral = require("/Users/me/Work/PublicRec-main/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMessage = void 0;

var chalk_1 = __importDefault(require("chalk"));
/**
 * Returns a function that returns a optionally colorized messaged prepended with an optionally colorize prefix.
 *
 * @export
 * @param {string} [prefix='']
 * @param {string} [color='black']
 * @returns {*}
 */


function formatMessage() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'black';
  return function (message) {
    var color2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'black';
    return chalk_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["{", " ", "} {", " ", "}"])), color, prefix, color2, message).trim();
  };
}

exports.formatMessage = formatMessage;